/**
 * シーンの余白の色 (TimelineItem.backgroundColor) の正本。
 *
 * 同じ意味・同じ規則の実装が 3 か所にある (どれかを変えたら必ず 3 つとも変える):
 * - ここ (image-generator FE: プレビュー・UI・拡張属性の正規化)
 * - video-editor リポジトリの src/schema/backgroundColor.ts (Cloud Run の MP4 レンダラー)
 * - backend/services/video_edit/background.py (AI 提案の正規化・引き継ぎ・要約)
 *
 * ## 意味
 * 映像 (静止画 / 動画) は出力の比率に contain で収まり、比率が違えば上下または左右に余白が
 * 出る。その余白の色を '#RRGGBB' で指定する。省略 = 黒 (従来どおり)。
 * シナリオの「静止画をそのまま使う」シーン (scenes.video_input_mode='still') では mapper が
 * scenes.still_background_color (既定 #FFFFFF) をここへ写す (静止画でも、差し込んだ動画素材でも同じ)。
 *
 * ## 表示
 * シーン層 (トランジションの opacity / transform を受ける AbsoluteFill) の最初の子として、
 * 出力全体を塗る AbsoluteFill を置く。映像エフェクトの transform (揺れ) や motion (ズーム) の
 * **外側**なので、揺れても縁に黒が覗かない。look (色補正) の外側でもあるので、白い余白が
 * グレーディングで色づくことはない。
 */

/** '#RRGGBB' (6 桁の 16 進) だけを受け付ける。 */
const BACKGROUND_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

/**
 * 外部入力 (AI / 保存値) の backgroundColor を '#RRGGBB' (大文字) に正規化する。
 * 不正な形式・空・null は undefined (= 属性なし。呼び出し側がキーごと落とす)。
 */
export function normalizeItemBackgroundColor(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const text = value.trim();
  return BACKGROUND_COLOR_PATTERN.test(text) ? text.toUpperCase() : undefined;
}
